import 'jquery-circle-progress';

$(document).ready(() => {

    $('.workflow').not('.non-sequential').each((i,e) => {

        const widget = $(e);

        const steps = widget.find('.workflow-pagination li');
        const headlines = widget.find('.section-intro');
        const texts = widget.find('.text');
        const icons = widget.find('.workflow-icon');

        const stepVal = 1 / steps.length;

        widget.find('.circle').circleProgress({
            value: stepVal,
            size: 724,
            thickness: 30,
            startAngle: -Math.PI / 2,
            fill: "#f26331",
            emptyFill: "#f2f2f2"
        });

        widget.find('.workflow-pagination li').click((e, noProp) => {

            if(noProp) {
                e.stopPropagation();
            }

            const li = $(e.currentTarget);

            steps.removeClass('active');
            headlines.removeClass('active');
            icons.removeClass('active');
            texts.removeClass('active');

            let num = steps.index(li);

            li.addClass('active');
            $(headlines.get(num)).addClass('active');
            $(icons.get(num)).addClass('active');
            $(texts.get(num)).addClass('active');

            widget.find('.circle').circleProgress('value', stepVal * (num + 1));

        });
    });

    $('.workflow.non-sequential').each((i,e) => {

        const widget = $(e);

        const steps = widget.find('.workflow-pagination li');
        const headlines = widget.find('.section-intro');
        const texts = widget.find('.text');
        const icons = widget.find('.workflow-icon');

        const stepVal = 1 / steps.length;

        const startAngle = -Math.PI / 2;

        widget.find('.circle').circleProgress({
            value: stepVal,
            size: 724,
            thickness: 30,
            startAngle: startAngle,
            fill: "#f26331",
            emptyFill: "#f2f2f2"
        });

        widget.find('.workflow-pagination li').click((e, noProp) => {

            if(noProp) {
                e.stopPropagation();
            }

            const li = $(e.currentTarget);

            steps.removeClass('active');
            headlines.removeClass('active');
            icons.removeClass('active');
            texts.removeClass('active');

            let num = steps.index(li);

            li.addClass('active');
            $(headlines.get(num)).addClass('active');
            $(icons.get(num)).addClass('active');
            $(texts.get(num)).addClass('active');

            let angle = startAngle;
            //widget.find('.circle').circleProgress('value', stepVal * (num + 1));
            if(stepVal > 0) {
                let perc = stepVal * num + 1;
                let degrees = perc * 360.0;
                let radians = degrees * Math.PI / 180.0;
                angle = radians + startAngle;
            }
            widget.find('.circle').circleProgress({'startAngle': angle});
            widget.find('.circle').circleProgress('redraw');

        });
    });

});



// WEBPACK FOOTER //
// ./src/js/workflow.js